export const errorMessageGetter = ({ messages, message }) => {
  return messages.length ? messages : message;
};
